import { Injectable } from '@angular/core';
import { DataService } from '../data/data.service';
import { RequestParam } from 'src/app/connector-studio/interfaces';
import { environment } from 'src/environments/environment';
import { catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { ICompanySubscription } from '../../../app.model';
import { find as _find, get as _get, size as _size } from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class AppSwitcherService {

  constructor(private dataService: DataService) { }

  isPulseEntry: boolean = false;
  pulseEntry: any;

  latestEntries: any;

  appSwitcherDialog: any;

  getLatestEntries(companyId): Promise<ICompanySubscription[]>{
    return new Promise((resolve, reject)=>{
      try{
        const requestParam: RequestParam = {
          url: `${environment.subscriptionApiUrl}/company-subscription/${companyId}/latest`
        };
        if(this.latestEntries){
        this.pulseEntry = this.latestEntries.find((entry)=>{
          return entry.subscriptionPlan.product.productName?.toLowerCase() === "insights" || "pulse";
        });
        this.isPulseEntry = !!this.pulseEntry;
        resolve(this.latestEntries);
      }
      this.dataService.get(requestParam).subscribe((response)=>{
        if(_get(response, 'data') && _size(_get(response, 'data')) > 0 ){
          this.latestEntries = _get(response, 'data');
          this.pulseEntry = _find(_get(response, 'data'), (entry)=>{
            return entry.subscriptionPlan.product.productName?.toLowerCase() === "insights" || "pulse";
          });
          this.isPulseEntry = !!this.pulseEntry;
        }else{
          this.isPulseEntry = false;
        }
        resolve(this.latestEntries);
      })
    }catch(e){
      console.log(e);
      reject(e);
    }
    })
  }

  createPulseEntry(companyId: string){
    const productId = _get(this.pulseEntry, 'subscriptionPlan.product.id');
    const productName = _get(this.pulseEntry, 'subscriptionPlan.product.productName');
    const requestParam: RequestParam = {
        url: `${environment.subscriptionApiUrl}/company-subscription/validate-subscription`,
        param: {companyId, productId, productName}
    };
    return this.dataService.get(requestParam).subscribe({
      next: (res)=>{
        if(res && res.data){

        }
      },error: (err)=>{
        console.log(err);
      }
    })
  }

}
